import { SectionNode } from '../../'

export class ContentSectionNode extends SectionNode {}
